// import { useEffect, useRef, useState } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import { Viewer } from "@photo-sphere-viewer/core";
// import { MarkersPlugin } from "@photo-sphere-viewer/markers-plugin";
// import "@photo-sphere-viewer/core/index.css";
// import "@photo-sphere-viewer/markers-plugin/index.css";
// import { apiUrl } from "../apiUrl";
// import "../styles/GalleryPanoramaPage.css";

// const API_BASE = `${apiUrl}/api`;

// const GalleryPanoramaPage = () => {
//   const { plotId, index } = useParams();
//   const navigate = useNavigate();

//   const containerRef = useRef(null);
//   const viewerRef = useRef(null);
//   const overlayRef = useRef(null);

//   const [unit, setUnit] = useState(null);
//   const [fetchError, setFetchError] = useState(null);
//   const [isFetching, setIsFetching] = useState(true);
//   const [isLoaded, setIsLoaded] = useState(false);
//   const [showHeader, setShowHeader] = useState(false);

//   const currentIdx = parseInt(index) || 0;

//   // Fetch unit
//   useEffect(() => {
//     fetch(`${API_BASE}/unit/${plotId}`, {
//       headers: { Accept: "application/json" },
//     })
//       .then((r) => {
//         if (!r.ok) throw new Error("Unit not found");
//         return r.json();
//       })
//       .then((data) => setUnit(data))
//       .catch((err) => setFetchError(err.message))
//       .finally(() => setIsFetching(false));
//   }, [plotId]);

//   // Init PSV for current gallery image
//   useEffect(() => {
//     if (!unit || !containerRef.current) return;

//     const gallery = unit.gallery_images || [];
//     if (!gallery[currentIdx]) return;

//     // Destroy previous
//     viewerRef.current?._cleanup?.();
//     viewerRef.current?.destroy();
//     setIsLoaded(false);
//     setShowHeader(false);

//     viewerRef.current = new Viewer({
//       container: containerRef.current,
//       panorama: gallery[currentIdx],
//       defaultZoomLvl: 50,
//       mousewheelCtrlKey: false,
//       loadingImg: null,
//       loadingTxt: "",
//       navbar: ["zoom", "move", "caption", "fullscreen"],
//       plugins: [[MarkersPlugin, { markers: [] }]],
//     });

//     viewerRef.current.addEventListener("ready", () => {
//       setIsLoaded(true);
//       setTimeout(() => setShowHeader(true), 300);

//       // Gentle auto-rotate
//       let angle = 0;
//       let isInteracting = false;
//       let resumeTimeout = null;

//       const rotate = () => {
//         if (!isInteracting && viewerRef.current) {
//           angle += 0.002;
//           viewerRef.current.rotate({ yaw: Math.sin(angle) * 0.05, pitch: 0 });
//         }
//         viewerRef.current._rafId = requestAnimationFrame(rotate);
//       };
      
//       viewerRef.current._rafId = requestAnimationFrame(rotate);

//       const onInteractionStart = () => {
//         isInteracting = true;
//         clearTimeout(resumeTimeout);
//       };

//       const onInteractionEnd = () => {
//         clearTimeout(resumeTimeout);
//         resumeTimeout = setTimeout(() => {
//           isInteracting = false;
//         }, 2000);
//       };

//       const container = containerRef.current;
//       container.addEventListener("mousedown", onInteractionStart);
//       container.addEventListener("touchstart", onInteractionStart);
//       container.addEventListener("mouseup", onInteractionEnd);
//       container.addEventListener("touchend", onInteractionEnd);

//       viewerRef.current._cleanup = () => {
//         cancelAnimationFrame(viewerRef.current._rafId);
//         clearTimeout(resumeTimeout);
//         container.removeEventListener("mousedown", onInteractionStart);
//         container.removeEventListener("touchstart", onInteractionStart);
//         container.removeEventListener("mouseup", onInteractionEnd);
//         container.removeEventListener("touchend", onInteractionEnd);
//       };
//     });

//     return () => {
//       viewerRef.current?._cleanup?.();
//       viewerRef.current?.destroy();
//       viewerRef.current = null;
//     };
//   }, [unit, currentIdx]);

//   // Entry fade-in
//   useEffect(() => {
//     if (!overlayRef.current) return;
//     overlayRef.current.style.opacity = "1";
//     overlayRef.current.style.transition = "none";
    
//     const timer = setTimeout(() => {
//       if (overlayRef.current) {
//         overlayRef.current.style.transition = "opacity 0.7s ease-out";
//         overlayRef.current.style.opacity = "0";
//       }
//     }, 50);
    
//     return () => clearTimeout(timer);
//   }, []);

//   const navigateToIndex = (idx) => {
//     if (!overlayRef.current) return;
//     overlayRef.current.style.transition = "opacity 0.3s ease-in";
//     overlayRef.current.style.opacity = "1";
//     setTimeout(() => navigate(`/unit/${plotId}/gallery/${idx}`), 320);
//   };

//   const handleBack = () => {
//     if (overlayRef.current) {
//       overlayRef.current.style.transition = "opacity 0.4s ease-in";
//       overlayRef.current.style.opacity = "1";
//     }
//     setTimeout(() => navigate(`/unit/${plotId}`), 450);
//   };

//   // Loading state
//   if (isFetching) {
//     return (
//       <div className="gallery-loading">
//         <div className="gallery-loading-card">
//           <div className="gallery-loading-icon">🌐</div>
//           <div className="gallery-loading-text">Loading gallery...</div>
//         </div>
//       </div>
//     );
//   }

//   // Error state
//   if (fetchError || !unit) {
//     return (
//       <div className="gallery-error">
//         <div className="gallery-error-icon">⚠️</div>
//         <h2 className="gallery-error-title">{fetchError || "Unit not found"}</h2>
//         <button onClick={() => navigate(-1)} className="gallery-error-btn">
//           ← Go Back
//         </button>
//       </div>
//     );
//   }

//   const gallery = unit.gallery_images || [];
//   const total = gallery.length;

//   // Empty state
//   if (!total) {
//     return (
//       <div className="gallery-empty">
//         <div className="gallery-empty-icon">🖼️</div>
//         <div className="gallery-empty-text">No gallery images for this unit.</div>
//         <button onClick={() => navigate(-1)} className="gallery-error-btn">
//           ← Go Back
//         </button>
//       </div>
//     );
//   }

//   return (
//     <div className="gallery-container">
//       {/* Header */}
//       <div className={`gallery-header ${showHeader ? 'gallery-header-visible' : 'gallery-header-hidden'}`}>
//         <button onClick={handleBack} className="gallery-back-btn">
//           ← Back to Unit
//         </button>

//         <span className="gallery-title">
//           🌐 Unit {unit.plot_number} — Gallery
//         </span>

//         <span className="gallery-counter">
//           {currentIdx + 1} / {total}
//         </span>

//         <div className="gallery-nav">
//           <button
//             onClick={() => navigateToIndex((currentIdx - 1 + total) % total)}
//             disabled={total <= 1}
//             className="gallery-nav-btn"
//           >
//             ‹ Prev
//           </button>
//           <button
//             onClick={() => navigateToIndex((currentIdx + 1) % total)}
//             disabled={total <= 1}
//             className="gallery-nav-btn"
//           >
//             Next ›
//           </button>
//         </div>
//       </div>

//       {/* PSV Panorama */}
//       <div ref={containerRef} className="gallery-panorama" />

//       {/* Thumbnail Strip */}
//       {isLoaded && total > 1 && (
//         <div className="gallery-thumbnails">
//           {gallery.map((img, idx) => (
//             <img
//               key={idx}
//               src={img}
//               alt={`Gallery ${idx + 1}`}
//               onClick={() => navigateToIndex(idx)}
//               className={`gallery-thumbnail ${idx === currentIdx ? 'gallery-thumbnail-active' : ''}`}
//             />
//           ))}
//         </div>
//       )}

//       {/* Transition Overlay */}
//       <div ref={overlayRef} className="gallery-transition" />
//     </div>
//   );
// };

// export default GalleryPanoramaPage;

import { useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Viewer } from "@photo-sphere-viewer/core";
import { MarkersPlugin } from "@photo-sphere-viewer/markers-plugin";
import "@photo-sphere-viewer/core/index.css";
import "@photo-sphere-viewer/markers-plugin/index.css";
import { apiUrl } from "../apiUrl";
import "../styles/GalleryPanoramaPage.css";

const API_BASE = `${apiUrl}/api`;

const GalleryPanoramaPage = () => {
  const { plotId, index } = useParams();
  const navigate = useNavigate();

  const containerRef = useRef(null);
  const viewerRef = useRef(null);
  const overlayRef = useRef(null);

  const [unit, setUnit] = useState(null);
  const [fetchError, setFetchError] = useState(null);
  const [isFetching, setIsFetching] = useState(true);
  const [isLoaded, setIsLoaded] = useState(false);
  const [showHeader, setShowHeader] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const currentIdx = parseInt(index) || 0;

  // Fetch unit
  useEffect(() => {
    fetch(`${API_BASE}/unit/${plotId}`, {
      headers: { Accept: "application/json" },
    })
      .then((r) => {
        if (!r.ok) throw new Error("Unit not found");
        return r.json();
      })
      .then((data) => setUnit(data))
      .catch((err) => setFetchError(err.message))
      .finally(() => setIsFetching(false));
  }, [plotId]);

  // Init PSV for current gallery image
  useEffect(() => {
    if (!unit || !containerRef.current) return;

    const gallery = unit.gallery_images || [];
    if (!gallery[currentIdx]) return;

    // Destroy previous
    viewerRef.current?._cleanup?.();
    viewerRef.current?.destroy();
    setIsLoaded(false);
    setShowHeader(false);
    setIsTransitioning(false);

    // Reset overlay opacity for new image
    if (overlayRef.current) {
      overlayRef.current.style.opacity = "0";
      overlayRef.current.classList.remove("gallery-transition-active");
    }

    viewerRef.current = new Viewer({
      container: containerRef.current,
      panorama: gallery[currentIdx],
      defaultZoomLvl: 50,
      mousewheelCtrlKey: false,
      loadingImg: null,
      loadingTxt: "",
      navbar: ["zoom", "move", "caption", "fullscreen"],
      plugins: [[MarkersPlugin, { markers: [] }]],
    });

    viewerRef.current.addEventListener("ready", () => {
      setIsLoaded(true);
      setTimeout(() => setShowHeader(true), 300);

      // Gentle auto-rotate
      let angle = 0;
      let isInteracting = false;
      let resumeTimeout = null;

      const rotate = () => {
        if (!isInteracting && viewerRef.current) {
          angle += 0.002;
          viewerRef.current.rotate({ yaw: Math.sin(angle) * 0.05, pitch: 0 });
        }
        viewerRef.current._rafId = requestAnimationFrame(rotate);
      };
      
      viewerRef.current._rafId = requestAnimationFrame(rotate);

      const onInteractionStart = () => {
        isInteracting = true;
        clearTimeout(resumeTimeout);
      };

      const onInteractionEnd = () => {
        clearTimeout(resumeTimeout);
        resumeTimeout = setTimeout(() => {
          isInteracting = false;
        }, 2000);
      };

      const container = containerRef.current;
      container.addEventListener("mousedown", onInteractionStart);
      container.addEventListener("touchstart", onInteractionStart);
      container.addEventListener("mouseup", onInteractionEnd);
      container.addEventListener("touchend", onInteractionEnd);

      viewerRef.current._cleanup = () => {
        cancelAnimationFrame(viewerRef.current._rafId);
        clearTimeout(resumeTimeout);
        container.removeEventListener("mousedown", onInteractionStart);
        container.removeEventListener("touchstart", onInteractionStart);
        container.removeEventListener("mouseup", onInteractionEnd);
        container.removeEventListener("touchend", onInteractionEnd);
      };
    });

    return () => {
      viewerRef.current?._cleanup?.();
      viewerRef.current?.destroy();
      viewerRef.current = null;
    };
  }, [unit, currentIdx]);

  // Entry fade-in - only on first load
  useEffect(() => {
    if (!overlayRef.current) return;
    
    // Only run entry animation on component mount
    const timer = setTimeout(() => {
      if (overlayRef.current) {
        overlayRef.current.style.transition = "opacity 0.7s ease-out";
        overlayRef.current.style.opacity = "0";
      }
    }, 100);
    
    return () => clearTimeout(timer);
  }, []);

  const navigateToIndex = (idx) => {
    if (!overlayRef.current) return;
    
    // Show overlay for transition
    overlayRef.current.style.transition = "opacity 0.3s ease-in";
    overlayRef.current.style.opacity = "1";
    overlayRef.current.classList.add("gallery-transition-active");
    
    // Navigate after a short delay
    setTimeout(() => {
      navigate(`/unit/${plotId}/gallery/${idx}`);
    }, 300);
  };

  const handleBack = () => {
    if (overlayRef.current) {
      overlayRef.current.style.transition = "opacity 0.4s ease-in";
      overlayRef.current.style.opacity = "1";
      overlayRef.current.classList.add("gallery-transition-active");
    }
    setTimeout(() => navigate(`/unit/${plotId}`), 450);
  };

  // Loading state
  if (isFetching) {
    return (
      <div className="gallery-loading">
        <div className="gallery-loading-card">
          <div className="gallery-loading-icon">🌐</div>
          <div className="gallery-loading-text">Loading gallery...</div>
        </div>
      </div>
    );
  }

  // Error state
  if (fetchError || !unit) {
    return (
      <div className="gallery-error">
        <div className="gallery-error-icon">⚠️</div>
        <h2 className="gallery-error-title">{fetchError || "Unit not found"}</h2>
        <button onClick={() => navigate(-1)} className="gallery-error-btn">
          ← Go Back
        </button>
      </div>
    );
  }

  const gallery = unit.gallery_images || [];
  const total = gallery.length;

  // Empty state
  if (!total) {
    return (
      <div className="gallery-empty">
        <div className="gallery-empty-icon">🖼️</div>
        <div className="gallery-empty-text">No gallery images for this unit.</div>
        <button onClick={() => navigate(-1)} className="gallery-error-btn">
          ← Go Back
        </button>
      </div>
    );
  }

  return (
    <div className="gallery-container">
      {/* Header */}
      <div className={`gallery-header ${showHeader ? 'gallery-header-visible' : 'gallery-header-hidden'}`}>
        <button onClick={handleBack} className="gallery-back-btn">
          ← Back to Unit
        </button>

        <span className="gallery-title">
          🌐 Unit {unit.plot_number} — Gallery
        </span>

        <span className="gallery-counter">
          {currentIdx + 1} / {total}
        </span>

        <div className="gallery-nav">
          <button
            onClick={() => navigateToIndex((currentIdx - 1 + total) % total)}
            disabled={total <= 1}
            className="gallery-nav-btn"
          >
            ‹ Prev
          </button>
          <button
            onClick={() => navigateToIndex((currentIdx + 1) % total)}
            disabled={total <= 1}
            className="gallery-nav-btn"
          >
            Next ›
          </button>
        </div>
      </div>

      {/* PSV Panorama */}
      <div ref={containerRef} className="gallery-panorama" />

      {/* Thumbnail Strip */}
      {isLoaded && total > 1 && (
        <div className="gallery-thumbnails">
          {gallery.map((img, idx) => (
            <img
              key={idx}
              src={img}
              alt={`Gallery ${idx + 1}`}
              onClick={() => navigateToIndex(idx)}
              className={`gallery-thumbnail ${idx === currentIdx ? 'gallery-thumbnail-active' : ''}`}
            />
          ))}
        </div>
      )}

      {/* Transition Overlay - initially transparent */}
      <div ref={overlayRef} className="gallery-transition" />
    </div>
  );
};

export default GalleryPanoramaPage;